import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { MarkantElementsModule } from '@markant/elements-angular';
import { OrganizationBookingsTableComponent } from './organization-bookings/organization-bookings-table.component';
import { SharedUiInfoCalloutModule } from '@markant-platform/shared/ui-info-callout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedUiFilterModule } from '@markant-platform/shared/ui-filter';
import {
  DefaultValuePipe,
  FormControlErrorPipe,
  FormControlKeyErrorPipe,
  SharedUtilPipesModule,
  TypeCastPipe,
} from '@markant-platform/shared/util-pipes';
import { TableComponent } from '@markant-platform/shared/table/feature';
import { UiCardComponent, UiCardItemComponent } from '@markant-platform/shared/ui-card';
import { RegistrationUserComponent, SharedRegistrationModule } from '@markant-platform/shared/registration';
import { SharedUiCalloutMessageModule } from '@markant-platform/shared/ui-callout-message';
import { SharedUiButtonsModule } from '@markant-platform/shared/ui-buttons';
import { ModalBridgeComponent } from '@markant-platform/shared/ui-modal';
import { OrganizationAddCartridgesDialogComponent } from './organization-add-cartridges-dialog/organization-add-cartridges-dialog.component';
import { RouterLink } from '@angular/router';
import { OrganizationAddCartridgesStepperComponent } from './organization-add-cartridges-stepper/organization-add-cartridges-stepper.component';
import { UsageRightEditModalComponent } from './organization-bookings/edit-usage-right-modal/usage-right-edit-modal.component';
import { OrganizationDetailsComponent } from './organization-details/organization-details.component';
import { SharedDialogFeatureModule } from '@markant-platform/shared/dialog/feature';
import { OrganizationMemberRemoveUserDialogComponent } from './organization-member-remove-user-dialog/organization-member-remove-user-dialog.component';
import { OrganizationMemberInvitationComponent } from './organization-member-invitation/organization-member-invitation.component';
import { OrganizationMemberSelectTemplateUserComponent } from './organization-member-invitation/organization-member-select-template-user/organization-member-select-template-user.component';
import { OrganizationMemberInvitationStepperComponent } from './organization-member-invitation-stepper/organization-member-invitation-stepper.component';
import {
  UiCartridgeRolesAssignmentCardComponent,
  UiCartridgeRolesEditSuborganizationsComponent,
  UiGroupAssignedWithVariantsItemComponent,
  UiGroupSelectionItemComponent,
} from '@markant-platform/shared/authorizer/ui';
import { ScrollIndicatorDirective } from '@markant-platform/shared/util-scroll';
import {
  CartridgeRoleAssignmentComponent,
  CartridgeRoleEditSuborganizationsDialogComponent,
  ServiceResponsibilityAssignNewAdminComponent,
} from '@markant-platform/shared/authorizer/feature';
import { UiCountrySelectComponent, UiPageHeaderComponent } from '@markant-platform/shared/ui-components';
import { OrganizationMemberInvitationStepHeaderComponent } from './organization-member-invitation/organization-member-invitation-step-header/organization-member-invitation-step-header.component';
import { OrganizationMemberInvitationAddGroupComponent } from './organization-member-invitation/organization-member-invitation-add-group/organization-member-invitation-add-group.component';

@NgModule({
  imports: [
    CommonModule,
    TranslocoModule,
    MarkantElementsModule,
    SharedUiInfoCalloutModule,
    SharedUtilPipesModule,
    FormsModule,
    ReactiveFormsModule,
    SharedUiFilterModule,
    SharedDialogFeatureModule,
    SharedRegistrationModule,
    SharedUiCalloutMessageModule,
    SharedUiButtonsModule,
    ModalBridgeComponent,
    RouterLink,
    UiCardComponent,
    TableComponent,
    DefaultValuePipe,
    UiCardItemComponent,
    UiCartridgeRolesAssignmentCardComponent,
    ScrollIndicatorDirective,
    UiCartridgeRolesEditSuborganizationsComponent,
    CartridgeRoleEditSuborganizationsDialogComponent,
    CartridgeRoleAssignmentComponent,
    TypeCastPipe,
    FormControlErrorPipe,
    FormControlKeyErrorPipe,
    UiPageHeaderComponent,
    ServiceResponsibilityAssignNewAdminComponent,
    UiCountrySelectComponent,
    OrganizationMemberSelectTemplateUserComponent,
    OrganizationMemberInvitationStepHeaderComponent,
    RegistrationUserComponent,
    UiGroupAssignedWithVariantsItemComponent,
    UiGroupSelectionItemComponent,
    OrganizationMemberInvitationAddGroupComponent,
    OrganizationMemberInvitationComponent,
    OrganizationMemberInvitationStepperComponent,
  ],
  exports: [
    OrganizationBookingsTableComponent,
    OrganizationDetailsComponent,
    OrganizationAddCartridgesDialogComponent,
    UsageRightEditModalComponent,
    OrganizationMemberRemoveUserDialogComponent,
  ],
  declarations: [
    OrganizationDetailsComponent,
    OrganizationAddCartridgesDialogComponent,
    OrganizationAddCartridgesStepperComponent,
    OrganizationBookingsTableComponent,
    UsageRightEditModalComponent,
    OrganizationMemberRemoveUserDialogComponent,
  ],
})
export class SharedOrganizationFeatureModule {}
